/**
 * ============================================================
 * Português do Brasil
 * ============================================================
 *
 * Translators:
 *
 * lzcampos <luizedc1@gmail.com>
 */

export default {
	'AdvanceHelp': 'Você pode avançar no jogo usando o botão esquerdo do mouse, clicando em qualquer lugar na tela do jogo ou pressionar a barra de espaço.',
	'AllowPlayback': 'Clique aqui para permitir a reprodução de áudio',
	'Audio': 'Áudio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Ativar reprodução automática',
	'AutoPlaySpeed': 'Velocidade de reprodução automática',

	'Back': 'Voltar',
	'BackButton': 'Voltar',

	'Cancel': 'Cancelar',
	'Close': 'Fechar',
	'Confirm': 'Deseja sair?',
	'Credits': 'Créditos',

	'Delete': 'Apagar',
	'DialogLogButton': 'Mostrar registos de diálogo',

	'FullScreen': 'Tela Cheia',

	'Gallery': 'Galeria',

	'Help': 'Ajuda',
	'Hide': 'Esconder',
	'HideButton': 'Esconder caixa de texto',

	'iOSAudioWarning': 'As configurações de áudio não são suportadas no iOS',

	'KeyboardShortcuts': 'Atalhos de Teclado',

	'Language': 'Língua',
	'Load': 'Carregar',
	'LoadAutoSaveSlots': 'Jogos Salvos Automaticamente',
	'LoadButton': 'Abrir Tela de Carregamento',
	'Loading': 'Carregando',
	'LoadingMessage': 'Aguarde enquanto os recursos são carregados',
	'LoadSlots': 'Jogos Salvos',
	'LocalStorageWarning': 'O armazenamento local não está disponível neste navegador',
	'Log': 'Registo',

	'Music': 'Volume de Música',

	'NewContent': 'Há novo conteúdo disponível, recarregue a página para obter a versão mais recente',
	'NoSavedGames': 'Nenhum jogo salvo',
	'NoAutoSavedGames': 'Nenhum jogo salvo automaticamente',
	'NoDialogsAvailable': 'Não há diálogos disponíveis. Os diálogos aparecerão aqui quando ocorrerem no jogo',

	'OK': 'OK',
	'OrientationWarning': 'Por favor rode o seu dispositivo para jogar',
	'Overwrite': 'Substituir',

	'QuickButtons': 'Botões de acesso rápido',
	'QuickMenu': 'Menu de acesso rápido',
	'Quit': 'Sair',
	'QuitButton': 'Sair do Jogo',

	'Resolution': 'Resolução',

	'Save': 'Salvar',
	'SaveButton': 'Abrir tela de salvar.',
	'SaveInSlot': 'Salvar em slot',
	'SelectYourLanguage': 'Selecione seu idioma',
	'Settings': 'Configurações',
	'SettingsButton': 'Abrir a Tela de Configurações',
	'Show': 'Mostrar',
	'Skip': 'Ignorar',
	'SkipButton': 'Entrar em modo de ignorar',
	'SlotDeletion': 'Tem certeza de que deseja excluir este jogo?',
	'SlotOverwrite': 'Tem certeza de que deseja substituir este jogo?',
	'Sound': 'Volume de Som',
	'Start': 'Início',
	'Stop': 'Parar',

	'TextSpeed': 'Velocidade do Texto',

	'Video': 'Video Volume',
	'Voice': 'Volume de Voz',

	'Windowed': 'Em Janela'
};